/** @module grid */

const CELL_SIZE = 40

export const CELL_WIDTH = CELL_SIZE
export const CELL_HEIGHT = CELL_SIZE

export const MINI_CELL_HEIGHT = CELL_HEIGHT / 2

export const CELL_SPACING = 5
export const CELL_RADIUS = 5
export const X_OFFSET = 20
export const Y_OFFSET = 20

/**
 *@returns the svg x coordinate
 */
export function xCoord (index = 0, { xOffset, cellWidth, cellSpacing } = {}) {
  return xOffset + index * (cellWidth + cellSpacing)
}

export function yCoord (index = 0, {yOffset, cellHeight, cellSpacing}) {
  return yOffset + index * (cellHeight + cellSpacing)
}

export function xColCoord (index) {
  return xCoord(index, {xOffset: X_OFFSET, cellWidth: CELL_WIDTH, cellSpacing: CELL_SPACING})
}
export function yColCoord () {
  return Y_OFFSET
}

export function gridHeight (harmonica) {
  return (harmonica.maxBlowbends() + harmonica.maxDrawbends() + 2) * (CELL_HEIGHT + CELL_SPACING) +
          1 * MINI_CELL_HEIGHT +
          2 * Y_OFFSET
}

export function gridWidth (harmonica) {
  return harmonica.holes.length * CELL_WIDTH + (harmonica.holes.length - 1) * CELL_SPACING + 2 * X_OFFSET
}



// WEBPACK FOOTER //
// ./src/grid.js